import { Fab, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const StyledFab = styled(Fab)((props) => ({
    textTransform: 'capitalize',
    fontSize: '14px',
    height: '31px !important',
    margin: '8px 0px !important',
    width: '100% !important',
    backgroundColor: '#f7f8fa',
    color: '#01ae8f',
    boxShadow: 'none',
    border: '1px solid #01ae8f',
    overflowWrap: 'anywhere',
    lineHeight: 0,

    '& svg': {
        color: '#01ae8f',
        position: 'absolute',
        right: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
    },
    '&:hover': {
        backgroundColor: '#f7f8fa',
    },
    ...props.styles,
    '&.Mui-disabled': {
        backgroundColor: '#f7f8fa !important',
        border: '1px solid #8b909a !important',

        color: '#8b909a !important',
        '& svg': {
            color: '#8b909a !important',
        },
    },
}))

const AddAllButton = ({
    styles,
    active,
    iconName,
    startIcon,
    children,
    activeStyle,
    ...rest
}) => {
    return (
        <StyledFab variant="extended" size="small" styles={styles} {...rest}>
            {startIcon && (
                <Icon
                    name={iconName ? iconName : 'Forward'}
                    color={styles?.color ? styles.color : '#ffffff'}
                ></Icon>
            )}
            {children}

            {!startIcon && (
                <Icon
                    name={iconName ? iconName : 'ArrowSmall'}
                    color={styles?.color ? styles.color : '#ffffff'}
                ></Icon>
            )}
        </StyledFab>
    )
}

export default AddAllButton
